<template>
	<v-app app>
		<!-- Navigation -->
		<app-navigation></app-navigation>

		<!-- Sizes your content based upon application components -->
		<v-content>
			<!-- Provides the application the proper gutter -->
			<v-container fluid pa-0>
				<!-- Router View -->
				<router-view></router-view>
			</v-container>
		</v-content>

		<v-footer app absolute id="footer">
			<v-container>
				<v-layout align-center justify-end>
					<v-flex xs12>
						<p>
							&copy; {{ new Date().getFullYear() }} by
							<a
								href="https://jabaradev.com"
								class="color-primary-4"
								>Jabara Development Solutions LLC</a
							>
						</p>
						<p>
							<a class="color-primary-4" href="/acknowledgements"
								>Acknowledgements</a
							>
						</p>
					</v-flex>
				</v-layout>
			</v-container>
		</v-footer>
	</v-app>
</template>

<script>
import AppNavigation from './components/AppNavigation';
export default {
	name: 'App',
	components: {
		AppNavigation
	},
	data() {
		return {
			prevHeight: 0
		};
	},
	methods: {
		beforeLeave(element) {
			this.prevHeight = getComputedStyle(element).height;
		},
		enter(element) {
			const { height } = getComputedStyle(element);

			element.style.height = this.prevHeight;

			setTimeout(() => {
				element.style.height = height;
			});
		},
		afterEnter(element) {
			element.style.height = 'auto';
		}
	}
};
</script>

<style src="./style.css"></style>
